import Tenants from "./Tenants";
import AddTenantDialog from "./AddTenantDialog";

export { Tenants, AddTenantDialog };
